import { render, staticRenderFns } from "./settingBusinessSegment.vue?vue&type=template&id=11e042b3&"
import script from "./settingBusinessSegment.vue?vue&type=script&lang=js&"
export * from "./settingBusinessSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports